import React, {
  useState,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import { toast } from 'react-toastify';

import { TextField, Button, ButtonGroup, Typography } from '@material-ui/core';
import { isArray, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { Table, Modal } from '~/components';
import { t } from '~/helpers';
import api from '~/services/api';

import { ProfileForm } from '..';

import * as S from './styles';

export default function Profiles({ report, nameReport }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [childrens, setChildrens] = useState([]);
  const [active, setActive] = useState({});

  const modalRef = useRef(null);
  const modalDeleteRef = useRef(null);

  const cellsProfiles = useMemo(
    () => [
      {
        id: 'nomeperfilrelatorio',
        label: t('s.geral.descricaoperfil'),
      },
    ],
    []
  );

  const cellsDescription = useMemo(
    () => [
      {
        id: 'codigolabelsistema',
        label: t('s.geral.descricaocampo'),
      },
    ],
    []
  );

  const handleGetAPI = useCallback(async () => {
    try {
      setLoading(true);
      setActive({});
      setChildrens([]);

      const { data } = await api.get('perfisrelatorios', {
        params: {
          wherefield: ['idgrupocamposistema'],
          valuewherefield: [report],
          listatodos: 0,
          pesquisalista: true,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      setItems(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [report]);

  const handleGetChildrensAPI = useCallback(async (value) => {
    try {
      setLoading(true);

      if (isArray(value) && value[0]) {
        const id = value.shift().idperfilrelatorio;

        const { data } = await api.get(`/perfisrelatorios/${id}`, {
          params: { pesquisalista: true },
        });

        setActive(data);
        setChildrens(
          data.campos.map((item) => ({
            ...item,
            codigolabelsistema: t(item.codigolabelsistema),
          }))
        );
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, []);

  const handleRemoveAPI = useCallback(async () => {
    try {
      await api.delete(`perfisrelatorios/${active.idperfilrelatorio}`);

      toast.success(t('s.geral.sucessoexclusao'));
      modalDeleteRef.current.handleCloseModal();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [active]);

  useEffect(() => {
    handleGetAPI();
  }, [handleGetAPI]);

  const actions = useMemo(
    () => [
      {
        label: 'Cancelar',
        variant: 'text',
        color: 'primary',
        callback: () => modalDeleteRef.current.handleCloseModal(),
      },
      {
        label: 'Sim, Continuar',
        variant: 'text',
        color: 'primary',
        callback: () => handleRemoveAPI(),
      },
    ],
    [handleRemoveAPI]
  );

  const ProfileFormModalComponent = useCallback(
    (props) => <ProfileForm {...props} report={report} />,
    [report]
  );

  const DeleteConfirmationModalComponent = useCallback(
    () => (
      <div style={{ textAlign: 'center' }}>
        <Typography>
          Esta acao nao podera mais ser desfeita pelo sistema.
        </Typography>
      </div>
    ),
    []
  );

  return (
    <S.Wrapper>
      <TextField
        fullWidth
        disabled
        value={nameReport}
        variant="outlined"
        size="small"
        label={t('s.geral.nomerelatorio')}
        InputLabelProps={{ shrink: true }}
      />

      <div className="__group_buttons">
        <ButtonGroup variant="contained" color="primary">
          <Button
            type="button"
            onClick={() => modalRef.current.handleOpenModal()}
          >
            {t('s.geral.botaoincluir')}
          </Button>

          <Button
            type="button"
            disabled={isEmpty(active)}
            onClick={() => modalRef.current.handleOpenModal({ active })}
          >
            {t('s.geral.botaoalterar')}
          </Button>

          <Button
            type="button"
            disabled={isEmpty(active)}
            onClick={() => modalDeleteRef.current.handleOpenModal({ active })}
          >
            {t('s.geral.botaoexcluir')}
          </Button>
        </ButtonGroup>
      </div>

      <Table
        noButton
        size="small"
        cells={cellsProfiles}
        data={items}
        loading={loading}
        onCallback={handleGetChildrensAPI}
        paginate={99999}
        maxHeight={200}
        showPagination={false}
      />

      <Table
        size="small"
        cells={cellsDescription}
        data={childrens}
        loading={loading}
        paginate={99999}
        maxHeight={200}
        showPagination={false}
      />

      <Modal
        ref={modalRef}
        form
        disableBackdropClick
        disableEscapeKeyDown
        fullScreen={window.innerWidth <= 425}
        // loading={sending}
        maxWidth="md"
        title={t('s.menu.cadastro.usuario.perfil')}
        component={ProfileFormModalComponent}
        onClose={handleGetAPI}
      />

      <Modal
        ref={modalDeleteRef}
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        title="Continuar exclusão?"
        component={DeleteConfirmationModalComponent}
        onClose={handleGetAPI}
        actions={actions}
      />
    </S.Wrapper>
  );
}

Profiles.propTypes = {
  report: PropTypes.number.isRequired,
  nameReport: PropTypes.string.isRequired,
};

